// Web-only stand-in for the "react-native" module.
//
// webpack.config.js aliases `react-native$` here instead of straight to
// react-native-web. Everything is re-exported untouched; the only additions are
// the PropTypes exports that react-native removed in 0.66 but that older
// libraries still import. react-native-material-dropdown (and its dependency
// react-native-material-textfield) do `(ViewPropTypes || View.propTypes).style`
// at module scope, which throws on web because neither exists in
// react-native-web — taking down every screen that imports them.
//
// Only the shape matters: these validators are never used for real type
// checking on the web build.

import PropTypes from "prop-types";

// Imported by full path with the extension: webpack.config.js aliases the
// extensionless "react-native-web/dist/index" here, and a bare
// "react-native-web" would resolve to that same request and loop back.
export * from "react-native-web/dist/index.js";

const styleProp = PropTypes.any;

export const ViewPropTypes = {
	style: styleProp,
	accessible: PropTypes.bool,
	accessibilityLabel: PropTypes.node,
	hitSlop: PropTypes.any,
	nativeID: PropTypes.string,
	onLayout: PropTypes.func,
	pointerEvents: PropTypes.oneOf(["auto", "box-none", "box-only", "none"]),
	removeClippedSubviews: PropTypes.bool,
	testID: PropTypes.string,
};

export const TextPropTypes = {
	style: styleProp,
	allowFontScaling: PropTypes.bool,
	ellipsizeMode: PropTypes.string,
	numberOfLines: PropTypes.number,
	onLayout: PropTypes.func,
	onPress: PropTypes.func,
	selectable: PropTypes.bool,
	testID: PropTypes.string,
};

export const ImagePropTypes = {
	style: styleProp,
	source: PropTypes.any,
	resizeMode: PropTypes.string,
	onError: PropTypes.func,
	onLoad: PropTypes.func,
	testID: PropTypes.string,
};

export const ColorPropType = PropTypes.any;
export const EdgeInsetsPropType = PropTypes.any;
export const PointPropType = PropTypes.any;
